export default __webpack_public_path__ + "static/media/33.5a40f0ce.jpg";